<script>
  import { Link } from 'svelte-navigator'
</script>

<header>
    <nav class="amber black-text">
        <ul>
            <li>
                <Link to="/">Accueil</Link>
            </li>
            <li>
                <Link to="planets">Planètes</Link>
            </li>
            <li>
                <Link to="films">Films</Link>
            </li>
        </ul>
    </nav>
</header>
